"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GraphQLKetoImageAndRating = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _apollo = require("@nerdwallet/apollo");
var _deprecate = require("@nerdwallet/deprecate");
var _reactMarketplaceCta = _interopRequireDefault(require("@nerdwallet/react-marketplace-cta"));
var _reactDisclaimerAd = require("@nerdwallet/react-disclaimer-ad");
var _reactMarketplaceApplyNow = _interopRequireWildcard(require("@nerdwallet/react-marketplace-apply-now"));
var _reactMarketplaceStarRating = _interopRequireWildcard(require("@nerdwallet/react-marketplace-star-rating"));
var _trkHelper = require("@nerdwallet/nw-client-lib/trk-helper");
var _impression = require("@nerdwallet/analytics/react/impression");
var _creditCards = require("@nerdwallet/marketplace/selectors/credit-cards");
var _constants = require("../lib/constants");
var _utils = require("../lib/utils");
var _ketoProductCardModule = _interopRequireDefault(require("./keto-product-card.module.css"));
var _matchScoreCta = _interopRequireWildcard(require("../match-score-cta/match-score-cta"));
var _reviwedAtInfo = _interopRequireDefault(require("./reviwed-at-info"));
var _templateObject;
var GraphQLKetoImageAndRating = function GraphQLKetoImageAndRating(_ref) {
  var analytics = _ref.analytics,
    approvalLikelihood = _ref.approvalLikelihood,
    className = _ref.className,
    disableAnnotation = _ref.disableAnnotation,
    id = _ref.id,
    identity = _ref.identity,
    imageDataSource = _ref.imageDataSource,
    increaseCardImageSize = _ref.increaseCardImageSize,
    marketplaceEntity = _ref.marketplaceEntity,
    legacyTrkProps = _ref.legacyTrkProps,
    productCardImage = _ref.productCardImage,
    reviewLinkOverride = _ref.reviewLinkOverride,
    secondaryCtas = _ref.secondaryCtas,
    shouldOmitCta = _ref.shouldOmitCta,
    shouldOmitRating = _ref.shouldOmitRating,
    showMatchScoreCTA = _ref.showMatchScoreCTA,
    showNotYetRated = _ref.showNotYetRated,
    riaDisclaimerDetails = _ref.riaDisclaimerDetails,
    shouldHighlightDrivers = _ref.shouldHighlightDrivers,
    riaReviewDateInfo = _ref.riaReviewDateInfo,
    shouldDisplayInlineCTA = _ref.shouldDisplayInlineCTA,
    header = _ref.header,
    postApplyOnClick = _ref.postApplyOnClick,
    trackNonMonetizingSegmentShoppingFinished = _ref.trackNonMonetizingSegmentShoppingFinished,
    isNwPlusVariant = _ref.isNwPlusVariant;
  /*
   * @todo https://nerdwallet.atlassian.net/browse/RUR-532 to get the actual matchScore
   * Leaving this for now because the field will be defined in the styleguide but will be undefined
   * for the client.
   */
  var matchScore = marketplaceEntity.matchScore;
  var _ref2 = legacyTrkProps !== null && legacyTrkProps !== void 0 ? legacyTrkProps : {},
    trkPageType = _ref2.trkPageType,
    trkProductPosition = _ref2.trkProductPosition,
    trkSectionCategory = _ref2.trkSectionCategory,
    taxonomy = _ref2.trkTaxonomy;
  var marketplaceStarRating = showNotYetRated ? [/*#__PURE__*/_react.default.createElement(_reactMarketplaceStarRating.GraphQlMarketplaceStarRating, {
    analytics: analytics,
    className: "".concat(_ketoProductCardModule.default.starRatingContainer, " ").concat(_ketoProductCardModule.default.noStarRatingWidth),
    marketplaceEntity: {},
    showNotYetRated: true,
    trkLocation: _constants.TRK_PRODUCT_LOCATION,
    trkPageType: trkPageType,
    key: "0"
  }), (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.reviewedAtDate) && (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.periodConsideredDate) && /*#__PURE__*/_react.default.createElement(_reviwedAtInfo.default, {
    periodConsideredDate: riaReviewDateInfo.periodConsideredDate,
    reviewedAtDate: riaReviewDateInfo.reviewedAtDate
  })] : [/*#__PURE__*/_react.default.createElement(_reactMarketplaceStarRating.GraphQlMarketplaceStarRating, {
    analytics: analytics,
    className: shouldHighlightDrivers || shouldDisplayInlineCTA ? _ketoProductCardModule.default.starRatingContainerInline : _ketoProductCardModule.default.starRatingContainer,
    shouldDisplayInline: increaseCardImageSize,
    layout: shouldHighlightDrivers || shouldDisplayInlineCTA ? _reactMarketplaceStarRating.LAYOUTS.SMALL_NUMERIC_INLINE : _reactMarketplaceStarRating.LAYOUTS.NUMERIC,
    marketplaceEntity: marketplaceEntity,
    omitRatingNumberHref: false,
    omitRatingTextHref: true,
    ratingTextHref: reviewLinkOverride,
    smallRatingText: true,
    trkLocation: _constants.TRK_PRODUCT_LOCATION // legacy tracking
    ,
    trkPageType: trkPageType // legacy tracking
    ,
    trkTaxonomy: taxonomy // legacy tracking
    ,
    key: "0"
  }), (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.reviewedAtDate) && (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.periodConsideredDate) && /*#__PURE__*/_react.default.createElement(_reviwedAtInfo.default, {
    periodConsideredDate: riaReviewDateInfo.periodConsideredDate,
    reviewedAtDate: riaReviewDateInfo.reviewedAtDate
  })];
  var productImageSection = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([_ketoProductCardModule.default.imageWrapper, _ketoProductCardModule.default.productImage, shouldDisplayInlineCTA && _ketoProductCardModule.default.inlineCTA])
  }, imageDataSource ? shouldOmitCta ? productCardImage : [/*#__PURE__*/_react.default.createElement(_reactMarketplaceCta.default, {
    analyticsPayloadOverrides: {
      element_position: trkProductPosition,
      product_impression_id: analytics === null || analytics === void 0 ? void 0 : analytics.product_impression_id
    },
    id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__product-image--").concat(trkProductPosition),
    gqlMarketplaceEntity: marketplaceEntity,
    legacyTrkProps: {
      trkElement: _trkHelper.TrkElement.image,
      trkPageType: trkPageType,
      trkSectionCategory: (0, _utils.buildTrkSectionCategory)(trkSectionCategory, 'productImage'),
      trkTaxonomy: taxonomy
    },
    linkType: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.productImage,
    omitImpression: true,
    reviewLinkOverride: reviewLinkOverride,
    trackNonMonetizingSegmentShoppingFinished: trackNonMonetizingSegmentShoppingFinished,
    key: "0"
  }, productCardImage), shouldDisplayInlineCTA && /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.secondaryCtas
  }, secondaryCtas)] : null);
  var starRatingSection = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([_ketoProductCardModule.default.starRating, shouldDisplayInlineCTA && _ketoProductCardModule.default.inlineCTA])
  }, showMatchScoreCTA && (0, _isNumber2.default)(matchScore) ? /*#__PURE__*/_react.default.createElement(_matchScoreCta.GraphqlMatchScoreCTA, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.matchScoreCTAProps,
    approvalLikelihood: approvalLikelihood,
    identity: identity,
    isKetoCard: true,
    marketplaceEntity: marketplaceEntity,
    taxonomy: taxonomy
  }) : !shouldOmitRating ? marketplaceStarRating : null, /*#__PURE__*/_react.default.createElement("div", null, !shouldHighlightDrivers && !shouldDisplayInlineCTA && secondaryCtas));
  var headerSection = /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.header
  }, header);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([increaseCardImageSize ? _ketoProductCardModule.default.enlargedProductImageLayout : '', _ketoProductCardModule.default.ketoImageAndRatingWrapper, shouldDisplayInlineCTA && _ketoProductCardModule.default.inlineCTA])
  }, increaseCardImageSize ? [productImageSection, starRatingSection] : [starRatingSection, productImageSection, shouldDisplayInlineCTA && headerSection], !shouldHighlightDrivers && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([_ketoProductCardModule.default.applyNow, (0, _defineProperty2.default)({}, _ketoProductCardModule.default.nwPlusVariantApplyNow, isNwPlusVariant)])
  }, /*#__PURE__*/_react.default.createElement(_reactMarketplaceCta.default, {
    analyticsPayloadOverrides: {
      element_position: trkProductPosition,
      product_impression_id: analytics === null || analytics === void 0 ? void 0 : analytics.product_impression_id
    },
    className: _ketoProductCardModule.default.productLink,
    disableAnnotation: disableAnnotation,
    gqlMarketplaceEntity: marketplaceEntity,
    id: id,
    legacyTrkProps: {
      trkPageType: trkPageType,
      trkSectionCategory: (0, _utils.buildTrkSectionCategory)(trkSectionCategory, 'cta'),
      trkTaxonomy: taxonomy
    },
    linkType: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.applyNowButton,
    omitImpression: true,
    reviewLinkOverride: reviewLinkOverride,
    onClick: !!postApplyOnClick && postApplyOnClick,
    trackNonMonetizingSegmentShoppingFinished: trackNonMonetizingSegmentShoppingFinished
  }))), !!(riaDisclaimerDetails !== null && riaDisclaimerDetails !== void 0 && riaDisclaimerDetails.text) && /*#__PURE__*/_react.default.createElement("div", {
    className: riaDisclaimerDetails !== null && riaDisclaimerDetails !== void 0 && riaDisclaimerDetails.isFidelity ? (0, _classnames.default)([_ketoProductCardModule.default.riaFidelityDisclaimerContainer]) : (0, _classnames.default)([_ketoProductCardModule.default.riaDisclaimerContainer])
  }, /*#__PURE__*/_react.default.createElement(_reactDisclaimerAd.DisclaimerAd, {
    renderAd: riaDisclaimerDetails === null || riaDisclaimerDetails === void 0 ? void 0 : riaDisclaimerDetails.renderAd,
    text: riaDisclaimerDetails === null || riaDisclaimerDetails === void 0 ? void 0 : riaDisclaimerDetails.text,
    tooltipContent: riaDisclaimerDetails === null || riaDisclaimerDetails === void 0 ? void 0 : riaDisclaimerDetails.tooltipContent
  })));
};
exports.GraphQLKetoImageAndRating = GraphQLKetoImageAndRating;
GraphQLKetoImageAndRating.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment GraphQLKetoImageAndRating on MarketplaceEntityInterface {\n    ...MarketplaceStarRating\n    ...GraphqlMatchScoreCTA\n  }\n  ", "\n  ", "\n"])), _reactMarketplaceStarRating.GraphQlMarketplaceStarRating.fragment, _matchScoreCta.GraphqlMatchScoreCTA.fragment);
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  GraphQLKetoImageAndRating.propTypes = {
    analytics: PropTypes.shape({
      entityName: PropTypes.string,
      matchScoreCTAProps: PropTypes.object,
      // eslint-disable-line react/forbid-prop-types
      product_impression_id: PropTypes.string
    }),
    approvalLikelihood: PropTypes.number,
    className: PropTypes.string,
    disableAnnotation: PropTypes.bool,
    id: PropTypes.string,
    identity: PropTypes.oneOfType([PropTypes.shape({
      vantageScore3: PropTypes.number
    }), PropTypes.shape({
      profiles: PropTypes.shape({
        tu_credit_report_profile: PropTypes.shape({
          vantage_score_3: PropTypes.number
        })
      })
    })]),
    imageDataSource: PropTypes.string,
    increaseCardImageSize: PropTypes.bool,
    legacyTrkProps: PropTypes.shape({
      trkPageType: PropTypes.string,
      trkProductPosition: PropTypes.number,
      trkSectionCategory: PropTypes.string,
      trkTaxonomy: PropTypes.shape({
        /** Taxonomy page type. */
        pageType: PropTypes.string,
        /** Taxonomy topic. */
        topic: PropTypes.string,
        /** Taxonomy vertical. */
        vertical: PropTypes.string
      })
    }),
    marketplaceEntity: PropTypes.shape({
      matchScore: PropTypes.number,
      reviewLink: PropTypes.string
    }),
    productCardImage: PropTypes.node,
    reviewLinkOverride: PropTypes.string,
    secondaryCtas: PropTypes.node,
    shouldOmitCta: PropTypes.bool,
    shouldOmitRating: PropTypes.bool,
    showMatchScoreCTA: PropTypes.bool,
    showNotYetRated: PropTypes.bool,
    shouldHighlightDrivers: PropTypes.bool,
    riaReviewDateInfo: PropTypes.shape({
      reviewedAtDate: PropTypes.string,
      periodConsideredDate: PropTypes.string
    }),
    shouldDisplayInlineCTA: PropTypes.bool,
    header: PropTypes.node,
    postApplyOnClick: PropTypes.func,
    trackNonMonetizingSegmentShoppingFinished: PropTypes.func
  };
}
var KetoImageAndRating = function KetoImageAndRating(_ref4) {
  var analytics = _ref4.analytics,
    className = _ref4.className,
    ctaHref = _ref4.ctaHref,
    ctaSubtext = _ref4.ctaSubtext,
    ctaShowIcon = _ref4.ctaShowIcon,
    ctaText = _ref4.ctaText,
    displayPage = _ref4.displayPage,
    enableAnalytics = _ref4.enableAnalytics,
    imageData = _ref4.imageData,
    id = _ref4.id,
    identity = _ref4.identity,
    secondaryCtas = _ref4.secondaryCtas,
    marketplaceEntity = _ref4.marketplaceEntity,
    omitCta = _ref4.omitCta,
    omitRating = _ref4.omitRating,
    productType = _ref4.productType,
    riaReviewDateInfo = _ref4.riaReviewDateInfo,
    reviewLinkHref = _ref4.reviewLinkHref,
    shouldLogImpression = _ref4.shouldLogImpression,
    starRating = _ref4.starRating,
    taxonomy = _ref4.taxonomy,
    trkPageType = _ref4.trkPageType,
    trkProductPosition = _ref4.trkProductPosition,
    trkSectionCategory = _ref4.trkSectionCategory,
    productCardImage = _ref4.productCardImage,
    showNotYetRated = _ref4.showNotYetRated,
    showMatchScoreCTA = _ref4.showMatchScoreCTA;
  var impressionContext = (0, _react.useContext)(_impression.ImpressionContext);
  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'KetoImageAndRating',
    deprecatedProps: [{
      component: 'KetoImageAndRating',
      deprecatedProps: [{
        version: '6.9.0',
        deprecated: 'enableAnalytics',
        migration: 'Use analytics instead.'
      }]
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var marketplaceStarRating = showNotYetRated ? [/*#__PURE__*/_react.default.createElement(_reactMarketplaceStarRating.default, {
    analytics: analytics,
    enableAnalytics: enableAnalytics || !(0, _isEmpty2.default)(analytics),
    marketplaceEntity: {},
    showNotYetRated: true,
    trkLocation: _constants.TRK_PRODUCT_LOCATION,
    trkPageType: trkPageType,
    className: "".concat(_ketoProductCardModule.default.starRatingContainer, " ").concat(_ketoProductCardModule.default.noStarRatingWidth),
    key: "0"
  }), (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.reviewedAtDate) && (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.periodConsideredDate) && /*#__PURE__*/_react.default.createElement(_reviwedAtInfo.default, {
    periodConsideredDate: riaReviewDateInfo.periodConsideredDate,
    reviewedAtDate: riaReviewDateInfo.reviewedAtDate
  })] : [/*#__PURE__*/_react.default.createElement(_reactMarketplaceStarRating.default, {
    analytics: analytics,
    enableAnalytics: enableAnalytics || !(0, _isEmpty2.default)(analytics),
    marketplaceEntity: marketplaceEntity,
    layout: _reactMarketplaceStarRating.LAYOUTS.NUMERIC,
    omitRatingNumberHref: false,
    omitRatingTextHref: true,
    smallRatingText: true,
    className: _ketoProductCardModule.default.starRatingContainer,
    productType: productType,
    ratingTextHref: reviewLinkHref,
    starRating: starRating,
    trkLocation: _constants.TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    trkPageType: trkPageType,
    trkTaxonomy: taxonomy,
    key: "0"
  }), (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.reviewedAtDate) && (riaReviewDateInfo === null || riaReviewDateInfo === void 0 ? void 0 : riaReviewDateInfo.periodConsideredDate) && /*#__PURE__*/_react.default.createElement(_reviwedAtInfo.default, {
    periodConsideredDate: riaReviewDateInfo.periodConsideredDate,
    reviewedAtDate: riaReviewDateInfo.reviewedAtDate
  })];
  var matchScore = (0, _creditCards.getMatchScore)(marketplaceEntity);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoImageAndRatingWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.starRating
  }, showMatchScoreCTA && matchScore ? /*#__PURE__*/_react.default.createElement(_matchScoreCta.default, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.matchScoreCTAProps,
    identity: identity,
    isKetoCard: true,
    marketplaceEntity: marketplaceEntity,
    taxonomy: taxonomy
  }) : !omitRating && marketplaceStarRating, /*#__PURE__*/_react.default.createElement("div", null, secondaryCtas)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([_ketoProductCardModule.default.imageWrapper, _ketoProductCardModule.default.productImage])
  }, (0, _get2.default)(imageData, 'src') ? omitCta ? productCardImage : /*#__PURE__*/_react.default.createElement(_reactMarketplaceApplyNow.default, {
    id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__product-image--").concat(trkProductPosition),
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.productImage,
    marketplaceEntity: marketplaceEntity,
    monetizable: (0, _utils.getMonetizable)(marketplaceEntity),
    productLocation: _constants.TRK_PRODUCT_LOCATION,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    trkElement: _trkHelper.TrkElement.image,
    trkPageType: trkPageType,
    trkSectionCategory: (0, _utils.buildTrkSectionCategory)(trkSectionCategory, 'productImage'),
    trkTaxonomy: taxonomy,
    type: _reactMarketplaceApplyNow.LINK_TYPES.LINK
    // BNK specific props
    ,
    displayPage: displayPage,
    disableBankCtaAnnotation: true
  }, productCardImage) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.applyNow
  }, /*#__PURE__*/_react.default.createElement(_reactMarketplaceApplyNow.default, {
    annotationText: ctaSubtext,
    className: _ketoProductCardModule.default.productLink,
    disableAnnotation: ctaSubtext === false,
    id: id,
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: _reactMarketplaceApplyNow.APPLY_NOW_LINK_TYPES.applyNowButton,
    marketplaceEntity: marketplaceEntity,
    monetizable: (0, _utils.getMonetizable)(marketplaceEntity),
    productLocation: _constants.TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    showIcon: ctaShowIcon,
    text: ctaText,
    trkPageType: trkPageType,
    trkSectionCategory: (0, _utils.buildTrkSectionCategory)(trkSectionCategory, 'cta'),
    trkTaxonomy: taxonomy,
    type: _reactMarketplaceApplyNow.LINK_TYPES.BUTTON
    // BNK specific props.
    ,
    displayPage: displayPage
  }))));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');
  KetoImageAndRating.propTypes = {
    className: _PropTypes.string,
    ctaHref: _PropTypes.string,
    ctaSubtext: _PropTypes.string,
    ctaShowIcon: _PropTypes.bool,
    ctaText: _PropTypes.string,
    imageData: _PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    id: _PropTypes.string,
    secondaryCtas: _PropTypes.node,
    marketplaceEntity: _PropTypes.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    omitCta: _PropTypes.bool,
    omitRating: _PropTypes.bool,
    productType: _PropTypes.string,
    reviewLinkHref: _PropTypes.string,
    shouldLogImpression: _PropTypes.bool,
    starRating: _PropTypes.number,
    taxonomy: _PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    trkPageType: _PropTypes.string,
    trkProductPosition: _PropTypes.number,
    trkSectionCategory: _PropTypes.string,
    productCardImage: _PropTypes.node,
    showNotYetRated: _PropTypes.bool,
    // BNK specific props.
    displayPage: _PropTypes.string,
    // analytics
    analytics: _PropTypes.shape({
      entityName: _PropTypes.string,
      matchScoreCTAProps: _PropTypes.object // eslint-disable-line react/forbid-prop-types
    }),

    /** @deprecated A flag to indicate if to send analytics */
    enableAnalytics: _PropTypes.bool,
    // cc specific props
    identity: _PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    showMatchScoreCTA: _PropTypes.bool,
    riaDisclaimerDetails: _PropTypes.shape({
      renderAd: _PropTypes.boolean,
      text: _PropTypes.string,
      isFidelity: _PropTypes.bool
    }),
    riaReviewDateInfo: _PropTypes.shape({
      reviewedAtDate: _PropTypes.string,
      periodConsideredDate: _PropTypes.string
    })
  };
}
KetoImageAndRating.defaultProps = {
  analytics: {},
  omitRating: false,
  displayPage: '',
  // CC specific props
  identity: {},
  showMatchScoreCTA: false,
  riaDisclaimerDetails: {
    renderAd: false,
    text: undefined,
    isFidelity: false
  }
};
var _default = KetoImageAndRating;
exports.default = _default;